<template>
<div class="Fdns-audit-fluid">
  <template v-if="!readOnly">
    <div class="fdnsaudit-data" :class="{ 'hidden-question' : cqa.IsHide }" style="width: 88%;">
      <label v-if="IsFDNSVisit === true">
        <ob-checkbox v-model="selected"><span>{{qNo}}. {{cqa.Question}} <i class="fa fa-info-circle" v-if="cqa.ToolTip && cqa.ToolTip != ''" v-tooltip="cqa.ToolTip"></i></span></ob-checkbox>
      </label>
      <label v-else>
        <span v-if="IsFilterApplied">
          <span>{{qNo}}. <span v-high-light-color:searchText="cqa.Question"></span><i class="fa fa-info-circle" v-if="cqa.ToolTip && cqa.ToolTip != ''" v-tooltip="cqa.ToolTip"></i></span>
        </span>
        <span v-else>
          <span>{{qNo}}. {{cqa.Question}} <i class="fa fa-info-circle" v-if="cqa.ToolTip && cqa.ToolTip != ''" v-tooltip="cqa.ToolTip"></i></span>
        </span>
      </label>
      <template v-if="IsFDNSVisit === false">
        <div class="disabled-answer" v-html="cqa.Answer && cqa.Answer ? cqa.Answer : 'N/A'"></div>
      </template>
      <template v-else> <!-- FDNS Visit UI -->
        <medium-editor :options="editorOptions" :text="cqa && cqa.Answer ? cqa.Answer : ''" @edit='processEditOperation' custom-tag='div' :class="{ 'medium-editor-element' : true, 'ob-vuelidate_input-error': validate && selected && (cqa.Answer == null || cqa.Answer == '') }" style="margin-left: 15px;"></medium-editor>
        <span style="margin-left: 15px;" class="ob-vuelidate_error-msg" v-if="validate && selected && (cqa.Answer == null || cqa.Answer == '')">Please enter answer</span>
      </template>
    </div>
    <div class="edit-row clearfix" v-if="IsFDNSVisit === false">
      <div class="edit-hide-data" style="margin-top: -45px;">
        <div class="hide-data">
          <a class="action-links text-red" href="javascript:;" v-if="cqa.CanDelete" @click="deleteQuestion">Delete</a>
          <a class="action-links text-red" href="javascript:;" style="cursor: not-allowed;" v-else v-tooltip="'You don\'t have permission to delete this question'">Delete</a>
          <span> | </span>

          <template v-if="isHRManager && $route.name == 'employee-specific-questions'">
            <template v-if="cqa.IsHide == false">
              <a class="action-links" href="javascript:;" @click="toggleQuestion('true')" v-tooltip="'If you \'Hide Question\', your employee will not be able to see this question in their list of FDNS Q&A list'" key="hidequestion">Hide</a>
              <span> | </span>
            </template>
            <template v-else>
              <a class="action-links" href="javascript:;" @click="toggleQuestion('false')" v-tooltip="'If you \'UnHide Question\', your employee will be able to see this question in their list of FDNS Q&A list'" key="unhidequestion">Unhide</a>
            </template>
          </template>

          <a class="action-links" href="javascript:;" @click="onUpdate" v-if="cqa.IsHide == false">Update</a>

        </div>

      </div>
    </div>
    <update-question-popup :show.sync="showUpdatePopup" :qa="cqa" @update:qa="$emit('questionupdated')"></update-question-popup>
  </template>
  <template v-else>
    <div class="fdnsaudit-data fdns-dadalabel">
      <label>
        <span>{{qNo}}. {{cqa.Question}}</span>
      </label>
      <p v-html="cqa.Answer && cqa.Answer != '' ? cqa.Answer : 'N/A'"></p>
    </div>
  </template>

  <!-- Attachment -->
  <a class="attachment-link" :href="cqa.AttachementUrl" target="_blank" v-if="cqa.AttachementUrl && cqa.AttachementUrl != ''" v-tooltip="attachfiletooltip"><i class="fa fa-paperclip"></i> {{cqa.AttachementUrl | URL2FileName}}</a>
  <!--// Attachment -->
</div>
</template>
<script>
import editor from "vue2-medium-editor";
import c from '@/components/Core/constants.js'
import UpdateQuestionPopUp from "../FDNS-PopUp/UpdateQuestionPopup.vue";
import { requiredIf } from "vuelidate/lib/validators";
export default {
  props: [
    "qa",
    "OrgId",
    "IsFDNSVisit",
    "readOnly",
    "qNo",
    "validate",
    "isSelected",
    "searchText"
  ],
  data() {
    return {
      selected: false,
      cqa: null,
      isEdit: true,
      showUpdatePopup: false,
      editorOptions: {
        placeholder: {
          text: "Enter Answer"
        },
        paste: {
          forcePlainText: false,
          cleanPastedHTML: false
        }
      }
    };
  },
  watch: {
    selected(v) {
      this.emitSelected(v);
    },
    qa: {
      handler(v) {
        this.cqa = v;
      },
      deep: true
    },
    cqa: {
      handler(v) {
        if (this.IsFDNSVisit) {
          // For FDNS Report only, we will be having checkbox, so check for selection
          if (this.selected === true) {
            this.$emit("onSelectedDataChange", v);
          }
        } else {
          this.$emit("update:qa", v);
        }
      },
      deep: true
    }
  },
  computed: {
    attachfiletooltip() {
      if (this.cqa.AttachementUrl != "") {
        return this.$options.filters.URL2FileName(this.cqa.AttachementUrl);
      } else {
        return " ";
      }
    },
    IsFilterApplied() {
      return this.$store.getters.getFDNSShowClearFilter;
    }
  },
  validations() {
    return {
      cqa: {
        Answer: {
          requiredIf: requiredIf(() => {
            return this.isEdit == true;
          })
        }
      }
    };
  },
  components: {
    "update-question-popup": UpdateQuestionPopUp,
    "medium-editor": editor
  },
  created() {
    this.cqa = __.cloneDeep(this.qa);
    this.selected = this.isSelected;
  },
  methods: {
    onUpdate() {
      this.showUpdatePopup = true;
    },
    deleteQuestion() {
      this.$alert2("Are you sure you want to delete the question ?", "Alert", {
        type: "confirm",
        yesButtonText: "Yes",
        noButtonText: "No",
        callback: action => {
          if (action === true) {
            this.$loading({ loadingText: "Deleting..." });
            let url = `/FDNSAudit/DeleteQuestion?questionId=${this.cqa.Id}`;
            if (this.isConsultant) {
              url += `&empOrgId=${this.$store.getters.getFDNSEmpOrgId}`;
            } else {
              url += `&empOrgId=''`;
            }
            ajax.put(url, {}, res => {
              this.$loading({ loadingText: "Deleting..." }).close();
              if (res.data.State === true) {
                this.$message({
                  type: "success",
                  message: "Question deleted successfully."
                });

                this.$emit("questiondeleted", this.cqa);
              } else {
                this.ESSEnableDisable(res)
                this.$message({
                  type: "error",
                  message: res.data.Message
                });
              }
            });
          }
        }
      });
    },
    processEditOperation(operation) {
      let text = operation.api.origElements.innerHTML;
      // Hot Fix
      // Since the original repo has this open issue
      // https://codesandbox.io/s/v841qqzmy7
      if (text == "<p><br></p>") {
        this.cqa.Answer = "";
      } else {
        this.cqa.Answer = operation.api.origElements.innerHTML;
      }

      // Auto select when user edits the answer
      if (this.IsFDNSVisit && !this.selected) {
        this.selected = true;
      }
    },
    emitSelected(v) {
      if (v === true) {
        this.$emit("onSelect", this.cqa);
      } else {
        this.$emit("onUnSelect", this.cqa);
      }
    },
    toggleQuestion(flag) {
      this.$loading({ loadingText: "Updating..." });
      let url = `/FDNSAudit/ShowOrHideQuestion?questionId=${
        this.cqa.Id
      }&isHide=${flag}`;
      ajax.put(url, {}, res => {
        this.cqa.IsHide = !this.cqa.IsHide;
        if (this.cqa.IsHide == true) {
          this.$loading().close();
          this.$message({
            type: "success",
            message: "Question Hidden Successfully"
          });
        } else {
          this.$loading().close();
          this.$message({
            type: "success",
            message: "Question Unhidden Successfully"
          });
        }
      });
    },
    saveAnswer() {
      this.$v.cqa.$touch();
      if (this.$v.cqa.$invalid != true) {
        // this.isEdit = false;

        this.$loading({ loadingText: "Saving..." });
        let params = {
          QuestionId: this.cqa.Id,
          Answer: this.cqa.Answer
        };
        let url = `/FDNSAudit/UpdateAnswer?empOrgId=${this.OrgId}`;

        ajax.put(url, params, res => {
          if (res.data.State == true) {
            this.$loading({}).close();
            this.openModal = false;
            this.$message({
              type: "success",
              message: "Answer updated Successfully"
            });
          } else {
            this.ESSEnableDisable(res)
            this.$message({
              type: "error",
              message: res.data.Message
            });
          }
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.fdnsaudit-data {
  margin: 15px 30px 15px 0;
  label {
    color: #666;
    font-size: 13px;
    font-weight: 600;
    margin: 0;
  }
  .ob-vuelidate_error-msg {
    color: #d60000;
    // margin-left: 15px;
    // margin-top: -8px;
    display: block;
  }
}
.edit-ans {
  text-decoration: underline;
  color: #4a90e2;
  font-size: 12px;
  font-style: italic;
  font-weight: 600;
  vertical-align: middle;
}
.hide-ans {
  text-decoration: underline;
  color: #d60000;
  font-size: 12px;
  font-style: italic;
  font-weight: 600;
  vertical-align: middle;
}

.edit-row {
  margin-left: 15px;
  .update-date {
    display: inline;
  }
  .edit-hide-data {
    float: right;
    .hide-answer {
      float: left;
      margin-right: 15px;
    }
    .edit-answer {
      float: right;
    }
  }
} //Main Section ENDS

//Main Section start
.answer-txt {
  display: block;
  margin: 10px 0;
  width: 100%;
  margin-left: 15px;
}

.manual-txt {
  display: inline;
  color: #b3b2bb;
  font-size: 12px;
  font-weight: 600;
  vertical-align: middle;
}
/* Change color of dropdown links on hover */

.Fdns-audit-fluid {
  padding: 10px 20px 0 20px;
}
.fdnsaudit-container {
  background: #fff;
}
.fdns-footer {
  padding: 0 0 20px 0;
  text-align: center;
}
// TABS STARTS
.fdns-header_tabs {
  margin: 20px 0 0 0;
  ul {
    padding: 0;
    width: 60%;
    display: inline-block;
    li {
      list-style: none;
      display: inline;
      padding: 7px 0px 7px 20px;
      a {
        font-size: 16px;
        font-weight: 600;
        color: #b0b2b5;
      }
    }
    li.active {
      border-bottom: 3px solid #2d4972;
      a {
        color: #143361;
      }
    }
  }
}
// TABS ENDS
.MT-Content {
  margin-top: 8%;
  text-align: center;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  display: block;
  font-weight: 600;
}
.heading-txt {
  padding: 15px 15px 5px 22px;
  border-bottom: 1px solid #4a90e3;
  position: -webkit-sticky;
  position: sticky;
  top: -15px;
  background: #fff;
  z-index: 1;
  p {
    color: #4a90e3;
    font-size: 14px;
    font-weight: 600;
  }
}

.fixed-dropdown {
  position: fixed;
  right: 15px;
  top: 191px;
  z-index: 2;
}
.fdns-dadalabel {
  label {
    span {
      font-size: 13px;
    }
  }
  p {
    padding-left: 15px;
    font-size: 13px;
  }
}

.hidden-question {
  opacity: 0.3;
}

.disabled-answer {
  background: #ebebeb;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px;
  margin: 10px 0 0 15px;
  overflow: hidden;
}

.action-links {
  font-style: italic;
  font-weight: bold;
  border-bottom: 1px solid #337ab7;
  color: #337ab7;

  &.text-red {
    color: #ce0b24;
    border-bottom: 1px solid #ce0b24;
  }
}

.attachment-link {
  display: inline-block;
  background: #dfeefe;
  color: #4e92df;
  border: 1px solid #4e92df;
  padding: 5px 15px;
  border-radius: 25px;
  font-weight: 600;
  margin-left: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 200px;

  .fa-paperclip {
    transform: rotateX(180deg);

    &::before {
      color: #4e92df;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/QA/Questions.vue